// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__d7dQ8","retracted":"Menu_retracted__Xaiaa","menuItem":"Menu_menuItem__l95NT","active":"Menu_active__fcOKs","title":"Menu_title__PX9Mf"};